export default __webpack_public_path__ + "943f653ae348326168c2430e5174590c.svg";